import React from 'react';
import ArrowRotateLeft from '@uber/base-icons/arrow-rotate-left';
import ArrowRotateRight from '@uber/base-icons/arrow-rotate-right';
import { useStyletron } from 'baseui';
import ToolbarButton from '../../../../common/toolbar-button';
import useAnalyticsFoStageToolBar from '../../../labelling/components/stage-toolbar/analytics/useAnalyticsForStageToolBar';
import { useStageSettings } from '../../hooks/use-stage-settings';
import { CONTROL_TYPES } from './constants';
import { ToolbarPopover } from './toolbar-popover';
const ROTATE_ACTION = Object.freeze({
  COUNTER_CLOCKWISE: 'COUNTER_CLOCKWISE',
  CLOCKWISE: 'CLOCKWISE'
});
export const SELECTOR_IDS = {
  ROTATE_LEFT: 'rotate-left-button',
  ROTATE_RIGHT: 'rotate-right-button',
  ROTATE_COMBINED: 'rotate-button'
};
const ROTATION_ANGLE = 90;
const rotateLeftAttributes = {
  'data-testid': 'rotate-left',
  'data-selector-id': SELECTOR_IDS.ROTATE_LEFT
};
const rotateRightAttributes = {
  'data-testid': 'rotate-right',
  'data-selector-id': SELECTOR_IDS.ROTATE_RIGHT
};
const rotateCombinedAttributes = {
  'data-testid': 'rotate-popover-button',
  'data-selector-id': SELECTOR_IDS.ROTATE_COMBINED
};
function RotateControl() {
  const [stageSettings, setStageSettings] = useStageSettings();
  const [css, theme] = useStyletron();
  const {
    sendEventChangeControls
  } = useAnalyticsFoStageToolBar();
  const onRotationClick = (action: (typeof ROTATE_ACTION)[keyof typeof ROTATE_ACTION]) => {
    const {
      rotation: existingRotation
    } = stageSettings;
    const rotation = action === ROTATE_ACTION.COUNTER_CLOCKWISE ? existingRotation === 0 ? ROTATION_ANGLE * 3 : existingRotation - ROTATION_ANGLE : existingRotation + ROTATION_ANGLE;
    sendEventChangeControls({
      action: action === ROTATE_ACTION.CLOCKWISE ? CONTROL_TYPES.ROTATE_CLOCKWISE : CONTROL_TYPES.ROTATE_COUNTER_CLOCKWISE,
      value: rotation.toString()
    });
    setStageSettings({
      ...stageSettings,
      rotation
    });
  };
  return <ToolbarPopover trigger={<ToolbarButton title="Rotate" attributes={rotateCombinedAttributes}>
          <ArrowRotateRight title="Rotate" />
        </ToolbarButton>}>
      <ToolbarButton title="Rotate Counter Clockwise" onClick={() => onRotationClick(ROTATE_ACTION.COUNTER_CLOCKWISE)} attributes={rotateLeftAttributes}>
        <ArrowRotateLeft title="Rotate left" />
      </ToolbarButton>
      <ToolbarButton title="Rotate Clockwise" onClick={() => onRotationClick(ROTATE_ACTION.CLOCKWISE)} attributes={rotateRightAttributes}>
        <ArrowRotateRight title="Rotate right" />
      </ToolbarButton>
    </ToolbarPopover>;
}
export default RotateControl;